import { get, put } from "./helpers";

//using this call to set user settings in redux
//api call to get sysaccty app-ui settings, then add the logo and avatar paths
//to get the logo and avatar images(get "/assets/logo" and get "/assets/avatar").
export const fetchUserSettings = async (id) => {
  const url = "/api/sysacct/settings/APPUI/@me";
  //const url = "/api/user-settings";
  const result = await get(url);

  const logo = {
    // logo: "/assets/logo",
    logo: `/assets/logo?${Date.now()}`,
  };
  const avatar = {
    // avatar: "/assets/avatar",
    //avatar: `/assets/avatar?${id ? id : 0}`,
    avatar: `/assets/avatar?${Date.now()}`,
  };

  return { ...result.data, ...avatar, ...logo };
  // if (result.status === 200) {
  //   return { ...result.data, ...avatar, ...logo };
  // } else {
  //   return result.data;
  // }
};

export const clearUserSettings = (id) => {
  const logo = {
    logo: `/assets/logo?${id ? id : 0}`,
  };
  const avatar = {
    avatar: `/assets/avatar?${id ? id : 0}`,
  };
  return { ...avatar, ...logo };
};

export const updateUserSettings = async (settings) => {
  const url = "/api/sysacct/settings/APPUI/@me";
  //const url = "/api/user-settings";
  const result = await put(url, settings);

  //return result.data;
  return result;
};

export const fetchMyAvatar = async () => {
  const url = `/assets/avatar`;
  const result = await get(url);

  return result.data;
};

export const fetchMyLogo = async () => {
  const url = `/assets/logo`;
  const result = await get(url);
  //console.log("FetchAvatarREsults " + JSON.stringify(result));
  console.log(result);
  return result.data;
};

export const fetchAppSettingByID = async (id, authToken) => {
  const url = `/api/agency/app-settings/${id}`;
  // const result = await get(url);
  // console.log(result.data);
  // return result.data;

  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : undefined;
  const result = await get(url, headers);
  return result.data;
};

export const fetchTimeOffset = async () => {
  const url = `/api/agency/app-settings/36`;
  const result = await get(url);

  return result.data;
};
